import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import keycloak from './keycloak'

import './assets/main.css'

keycloak
.init({
  onLoad: 'login-required',
  checkLoginIframe: false,
  pkceMethod: 'S256',
})
.then(authenticated => {
  if (!authenticated) {
    console.log('User not authenticated, redirecting to login...')
    keycloak.login()
  } else if (!keycloak.hasRealmRole('PLATFORM_ADMIN')) {
    // Acces reserve aux administrateurs de la plateforme (le backend renvoie aussi 403).
    renderAuthError(
      `Le compte ${keycloak.tokenParsed?.preferred_username || ''} n'a pas le rôle PLATFORM_ADMIN.`,
      { title: 'Accès refusé', intro: 'Cette console est réservée aux administrateurs de la plateforme Wheere.',
        button: 'Se déconnecter', onClick: () => keycloak.logout() },
    )
  } else {
    console.log('Authenticated ✅')
    console.log('User:', keycloak.tokenParsed?.preferred_username)

    const app = createApp(App)
    app.config.globalProperties.$keycloak = keycloak
    app.use(router)
    app.mount('#app')
  }
})
.catch(err => {
  console.error('Keycloak init error:', err)
  renderAuthError(err && err.message ? err.message : String(err))
})

// Fallback d'erreur d'auth construit en DOM (pas d'innerHTML avec du contenu dynamique)
function renderAuthError(message, opts = {}) {
  const wrap = document.createElement('div')
  Object.assign(wrap.style, {
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    height: '100vh', fontFamily: "'Lato', Arial, sans-serif", background: '#f9fafb',
  })
  const card = document.createElement('div')
  Object.assign(card.style, {
    textAlign: 'center', padding: '28px 32px', border: '1px solid #e5e7eb',
    borderRadius: '16px', background: '#fff', boxShadow: '0 4px 6px -1px rgba(0,0,0,.08)', maxWidth: '420px',
  })
  const h = document.createElement('h2')
  h.textContent = opts.title || "Erreur d'authentification"
  Object.assign(h.style, { color: '#ED107D', margin: '0 0 8px', fontWeight: '700' })
  const p1 = document.createElement('p')
  p1.textContent = opts.intro || "Impossible d'initialiser l'authentification."
  Object.assign(p1.style, { margin: '0 0 4px', color: '#374151' })
  const p2 = document.createElement('p')
  p2.textContent = message
  Object.assign(p2.style, { color: '#6b7280', fontSize: '13px', margin: '0 0 16px' })
  const btn = document.createElement('button')
  btn.textContent = opts.button || 'Réessayer'
  Object.assign(btn.style, {
    padding: '9px 18px', background: '#ED107D', color: '#fff', border: 'none',
    borderRadius: '8px', cursor: 'pointer', fontWeight: '600',
  })
  btn.addEventListener('click', opts.onClick || (() => window.location.reload()))
  card.append(h, p1, p2, btn)
  wrap.appendChild(card)
  document.body.appendChild(wrap)
}
